import { IconType } from "react-icons";
import PropTypes from "prop-types";
interface IconStar {
    icon: IconType;
    width?: string | number;
    color?: string;
    onClick?: () => void;
    className?: string;
    onMouseEnter?: () => void;
    onMouseLeave?: () => void;
}

const IconComponent: React.FC<IconStar> = ({ 
    icon: Icon, 
    width = "1em", 
    color = '#000', 
    onClick = () => {},
    className = "",
    onMouseEnter,
    onMouseLeave,
}) => {
    return <Icon size={width} color={color} onClick={onClick} className={className} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}/>;
};

IconComponent.propTypes = {
    icon: PropTypes.func.isRequired,
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    color: PropTypes.string,
    onClick: PropTypes.func,
    className: PropTypes.string,
};

export default IconComponent;